import acc from "accounting"
import { Flex, Tooltip, Typography } from "antd"

import Private from "../../../../Components/Private"
import Icon from "../../../../Icon"

import "./chargebackOlympicsColumns.less"

const { Text, Link } = Typography

export const formatCount = (am) => acc.formatNumber(am, 0, ",", ".")
export const formatAmount = (am) => `$${acc.formatNumber(am, 2, ",", ".")}`

export const getColumns = ({ t, isFullTable, withSort }) => [
  {
    key: "customer_name",
    title: t("Customer name"),
    dataIndex: "customer_name",
    className: "customer-name-column",
    render: (_, record) => (
      <Flex gap={8}>
        {record?.sequence_number <= 3 ? (
          <Icon type={`medal${record?.sequence_number}`} />
        ) : (
          <Text
            style={{
              display: "inline-block",
              minWidth: "20px",
              textAlign: "center",
              whiteSpace: "nowrap"
            }}
          >
            {record?.sequence_number}
          </Text>
        )}
        {_ && _ !== "N/A" ? (
          record?.stripe_link || record?.shopify_link ? (
            <Link
              href={record?.stripe_link || record?.shopify_link}
              target="_blank"
              style={{ wordBreak: "normal" }}
            >
              <Private>{_}</Private>
            </Link>
          ) : (
            <Text>
              <Private>{_}</Private>
            </Text>
          )
        ) : (
          <Tooltip title={"Customer information is missing, or the account no longer exists"}>
            <Text>{"N/A"}</Text>
          </Tooltip>
        )}
      </Flex>
    )
  },
  {
    key: "email",
    title: t("Email"),
    dataIndex: "email",
    className: "email-column",
    render: (_, record) =>
      _ && _ !== "N/A" ? (
        <Text>
          <Private>{_}</Private>
        </Text>
      ) : (
        <Tooltip title={"Customer information is missing, or the account no longer exists"}>
          <Text>{"N/A"}</Text>
        </Tooltip>
      )
  },
  {
    key: "chargebacks_count",
    title: t("Chargebacks"),
    dataIndex: "chargebacks_count",
    width: 136,
    className: "chargebacks-count-column",
    render: (_, record) => {
      const count = record?.["chargebacks_count"]
      if (count === "-") return <Text>-</Text>
      return <Text>{formatCount(count)}</Text>
    }
  },
  {
    hidden: !isFullTable,
    key: "chargebacks_amount",
    title: t("Volume") + " ($)",
    dataIndex: "chargebacks_amount",
    width: 140,
    align: "right",
    render: (_, record) => (
      <Text>
        <Private>{formatAmount(record?.["chargebacks_amount"])}</Private>
      </Text>
    )
  },
  {
    key: "alerts_count",
    title: t("Alerts"),
    dataIndex: "alerts_count",
    width: 100,
    className: "alerts-count-column",
    render: (_, record) => {
      const count = record?.["alerts_count"]
      if (count === "-") return <Text>-</Text>
      return <Text>{formatCount(count)}</Text>
    }
  },
  {
    hidden: !isFullTable,
    key: "alerts_amount",
    title: t("Volume") + " ($)",
    dataIndex: "alerts_amount",
    width: 140,
    align: "right",
    render: (_, record) => (
      <Text>
        <Private>{formatAmount(record?.["alerts_amount"])}</Private>
      </Text>
    )
  },
  {
    hidden: !isFullTable,
    key: "country",
    title: t("Country"),
    dataIndex: "country",
    width: 164
  }
]
